import { Flex, Text } from "@chakra-ui/react";
import { useColor } from "@styles/useColor";
import { OperationTypes, type Transaction, TransactionDirections } from "@umami/chains";

import { NormalTransactionDetails } from "./NormalTransactionDetails";
import { SafeSendInfo } from "./SafeSendInfo";
import { SaplingTransactionDetails } from "./SaplingTransactionDetails";
import { getTransactionTitle } from "./utils";

type TransactionDirectionDetailsProps = {
  operation: Transaction;
};

export const TransactionDirectionDetails = ({ operation }: TransactionDirectionDetailsProps) => {
  const color = useColor();
  const { txDirection, to, from } = operation;
  const address = txDirection === TransactionDirections.SEND ? to : from;

  const isSafeSend = operation.operationType === OperationTypes.SAFE_SEND;
  const isSapling = operation.operationType === OperationTypes.SAPLING;
  const memo = isSapling ? (operation.memo as string | undefined) : undefined;
  const isReceived = txDirection === TransactionDirections.RECEIVE;

  return (
    <>
      <>
        <Text
          alignSelf="center"
          gridArea="title"
          marginRight="8px"
          color={color("900")}
          fontWeight={600}
        >
          {getTransactionTitle(operation)}
        </Text>
        {isSafeSend && (
          <SafeSendInfo
            justifyContent={{ base: "space-between", md: "unset" }}
            gridArea="safe-send"
            marginBottom={{ base: "12px", md: "0" }}
            operation={operation}
          />
        )}
      </>
      <Flex
        alignItems="center"
        justifyContent={{ base: "space-between", md: "unset" }}
        gap="8px"
        gridArea="details"
        marginTop="8px"
      >
        {isSapling ? (
          <SaplingTransactionDetails isReceived={isReceived} memo={memo} />
        ) : (
          <NormalTransactionDetails
            address={address}
            operation={operation}
            txDirection={txDirection}
          />
        )}
      </Flex>
    </>
  );
};
